import { makeStyles } from "@material-ui/core/styles";
import { colors } from "@utils/constant";

const TableStyle = makeStyles({
  TableWrapper: {
    boxShadow: "0 3px 8px 0 rgba(97, 97, 97, 0.08)",
    backgroundColor: colors.white,
    borderRadius: "6px",
    "& .MuiBackdrop-root": {
      color: " #fff",
      zIndex: "1201",
    },
    "& .pagination-wrapper": {
      "& .MuiTablePagination-select": {
        paddingRight: "24px !important",
      },
      "@media (max-width: 575px)": {
        flexDirection: "column",
        alignItems: "flex-start",
        padding: "15px",
      },
      "@media (max-width: 374px)": {
        padding: "0",
      },
      "& .total-page p": {
        opacity: "0.7",
        "@media (max-width: 575px)": {
          marginBottom: "15px",
        },
      },
      "& .pagination": {
        display: "flex",
        alignItems: "center",
        "& li": {
          margin: "0 2px",
          "&:last-child": {
            marginLeft: "8px",
          },
          "&:first-child": {
            marginRight: "8px",
          },
          "&:hover a": {
            color: colors.white,
            borderColor: colors.orange,
            backgroundColor: colors.orange,
          },
          "&.no-link": {
            margin: "0 8px",
          },
          "&.disabled a": {
            opacity: "0.3",
            cursor: "default",
            color: colors.black,
            borderColor: "#c6cbd4",
            backgroundColor: "transparent",
          },
          "&.active a": {
            color: colors.white,
            borderColor: colors.orange,
            backgroundColor: colors.orange,
          },
          "& a": {
            border: "solid 1px #c6cbd4",
            fontSize: "14px",
            color: colors.black,
            padding: "0px 10px",
            lineHeight: "1.2",
            borderRadius: "2px",
            height: "32px",
            width: "32px",
            display: "flex",
            textAlign: "center",
            textDecoration: "none !important",
            alignItems: "center",
            justifyContent: "center",
            "& .MuiSvgIcon-root": {
              height: "14px",
              width: "14px",
            },
          },
        },
      },
    },
  },
  customJobPoolTable: {
    marginTop: 25,
    maxHeight: 680,
    boxShadow: "none",
    "& .MuiTable-root": {
      minWidth: 1700,
      tableLayout: "fixed",
      "& .MuiTableCell-root": {
        fontWeight: 500,
        color: colors.black,
        border: "none",
      },
      "& .MuiTableHead-root": {
        boxShadow: "0 3px 8px 0 rgba(97, 97, 97, 0.08)",
        backgroundColor: colors.white,
        "& .MuiTableCell-root": {
          color: "rgba(33, 33, 33, 0.7)",
          padding: "30px 19px",
          backgroundColor: colors.white,
          borderBottom: "1px solid #f4f4f4",
          verticalAlign: "top",
          "&:first-child": {
            paddingLeft: "30px",
          },
          "&:last-child": {
            paddingRight: "30px",
          },
        },
      },
      "& .MuiTableBody-root": {
        "& .MuiTableCell-root": {
          padding: "22px 19px",
          "&:first-child": {
            paddingLeft: "30px",
          },
          "&:last-child": {
            paddingRight: "30px",
          },
          "&.status": {
            "& span": {
              position: "relative",
              paddingLeft: 20,
              display: "block",
              "&:before": {
                content: '""',
                position: "absolute",
                backgroundColor: colors.black,
                height: 10,
                width: 10,
                borderRadius: "50%",
                left: 0,
                top: 7,
              },
            },
            "&.not-assigned": {
              "& span": {
                color: colors.yellow,
                "&:before": {
                  backgroundColor: colors.yellow,
                },
              },
            },
            "&.rejected": {
              "& span": {
                color: colors.darkRed1,
                "&:before": {
                  backgroundColor: colors.darkRed1,
                },
              },
            },
          },
          "&.MuiTableCell-body": {
            wordBreak: "break-word",
          }
        },
      },
      "& .MuiTableRow-root": {
        "&.accordian-row": {
          transition: "all 0.3s",
          cursor: "pointer",
        },
        "&.sub-row": {
          "& .MuiTableSubRoW": {
            paddingBottom: 0,
            paddingTop: 0,
            backgroundColor: "#f6f6f6",
            "& .consolidated-job-collapse": {
              margin: "0px 20px 0px 50px",
            },
            "& .consolidated-job": {
              border: "2px solid #E7E9EC",
              borderRadius: "6px",
              boxShadow: "-1px 2px 19px -4px rgba(231, 233, 236, 1)",
              backgroundColor: "#ffffff",
            }
          },
          "& .MuiTableCell-root": {
            "&:first-child": {
              paddingLeft: "0px",
            },
            "&:last-child": {
              paddingRight: "0px",
            },
            "&.MuiTableCell-head": {
              backgroundColor: "#E7E9EC",
            },
            "& .MuiCollapse-wrapper": {
              margin: "10px 0",
            },
            "& .MuiTable-root": {
              minWidth: 1600,
              "& .MuiTableRow-root": {
                cursor: "default",
              },
              backgroundColor: "#f6f6f6",
              "& .MuiTableCell-root": {
                padding: "8px 20px",
              },
            },
          },
        },
      },
      "& .jobId": {
        width: "100px",
        whiteSpace: "nowrap",
        "& .prime-job": {
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        },
        "& .badge": {
          display: "inline-flex",
          alignItems: "center",
          marginLeft: 8,
          padding: "2px 8px",
          fontSize: 11,
          fontWeight: 600,
          color: colors.white,
          backgroundColor: colors.primary,
          borderRadius: 6,
          letterSpacing: 0.4,
          textTransform: "uppercase",
        },
        "& .consolidated-job-arrow": {
          transition: "transform 0.3s",
          fill: colors.gray2,
          "&.active": {
            transform: "translateY(0) rotate(0deg)",
          },
          "&.not-active": {
            transform: "translateY(0) rotate(-90deg)",
          },
        },
      },
      "& .truck": {
        width: "120px",
      },
      "& .check": {
        width: "30px",
      },
      "& .location": {
        width: "180px",
      },
      "& .customerName": {
        width: "160px",
      },
      "& .city": {
        width: "110px",
      },
      "& .cto": {
        width: "100px",
      },
      "& .cargoType": {
        width: "120px",
      },
      "& .jobType": {
        width: "130px",
      },
      "& .date": {
        width: "100px",
      },
      "& .status": {
        width: "90px",
      },
      "& .action": { //Temporary
        width: "80px",
        "& button": {
          margin: 0,
          background: "transparent !important",
          color: "#f79239 !important",
          border: "none !important",
          whiteSpace: "nowrap",
          padding: "0 5px",
        }
      }
    },
    "& .flex-box": {
      display: "flex",
      flexDirection: "row",
      alignItems: "flex-start",
      marginTop: "9px",
      "& .MuiTableSortLabel-root": {
        marginTop: "5px",
      },
      "&.jobId": {
        width: "100px",
      },
      "&.customerName": {
        width: "140px",
      },
      "&.city": {
        width: "80px",
      },
      "&.cto": {
        width: "100px",
      },
      "&.cargoType": {
        width: "80px",
      },
      "&.jobType": {
        width: "80px",
      },
      "&.date": {
        width: "90px",
      },
    },
  },
});

export { TableStyle };
